import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { fileUrl, formatDate } from "@/lib/api";
import { PageHero, Empty } from "@/components/kit";
import { ArticleCard, useFetch } from "@/components/shared";
import { STRUCTURE_LABEL } from "@/lib/content";

const FILTERS = [["", "Toutes"], ["ong", "ONG"], ["association", "Association"], ["commun", "Commun"]];

export function FilterTabs({ value, onChange, options, testid }) {
  return (
    <div className="flex flex-wrap gap-2" role="tablist" data-testid={testid}>
      {options.map(([v, l]) => (
        <button key={v} role="tab" aria-selected={value === v} onClick={() => onChange(v)} data-testid={`${testid}-${v || "all"}`}
          className={`rounded-full px-4 py-2 font-display text-sm font-semibold uppercase tracking-wide transition-colors ${value === v ? "bg-ink text-white" : "bg-white text-neutral-700 hover:bg-neutral-200"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}

export default function News() {
  useSeo("Actualités", "Actualités de l'ONG MA LEBA et de l'ASSOCIATION MA LEBA.");
  const [cat, setCat] = useState("");
  const articles = useFetch(`/articles${cat ? `?category=${cat}` : ""}`, [cat]);
  return (
    <div data-testid="news-page">
      <PageHero eyebrow="Blog" title="Actualités" intro="Les nouvelles de nos actions à Makana et au-delà." />
      <section className="container-x py-14">
        <FilterTabs value={cat} onChange={setCat} options={FILTERS} testid="news-filter" />
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(articles || []).map((a, i) => <ArticleCard key={a.id} a={a} i={i} />)}
        </div>
        {articles && !articles.length && <Empty testid="news-empty">Aucun article pour le moment.</Empty>}
      </section>
    </div>
  );
}

export function ArticlePage() {
  const { slug } = useParams();
  const a = useFetch(`/articles/${slug}`, [slug]);
  useSeo(a?.title, a?.excerpt);
  if (!a) return <p className="container-x py-20">Chargement…</p>;
  if (Array.isArray(a)) return <div className="container-x py-20"><Empty testid="article-not-found">Article introuvable.</Empty></div>;
  return (
    <article className="pb-20" data-testid="article-page">
      <PageHero eyebrow={`${STRUCTURE_LABEL[a.category] || "Commun"} · ${formatDate(a.created_at)}`} title={a.title} intro={a.excerpt} image={fileUrl(a.cover_url)} />
      <div className="container-x mt-12 max-w-3xl">
        {a.cover_url && <img src={fileUrl(a.cover_url)} alt="" loading="lazy" className="mb-10 w-full rounded-xl object-contain shadow" />}
        <div className="whitespace-pre-line text-lg leading-relaxed text-neutral-800" data-testid="article-content">{a.content}</div>
        <Link to="/actualites" className="btn-outline mt-12 text-u" data-testid="article-back"><ArrowLeft className="h-4 w-4" /> Retour aux actualités</Link>
      </div>
    </article>
  );
}
